module.exports = __webpack_public_path__ + "static/media/icon-brand-icon-award.ae5936ea.svg";